function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.701,39.376c8.093,0 11.832,-4.686 13.062,-6.248c0.758,-0.946 0.616,-2.366 -0.378,-3.076c-0.379,-0.331 -0.852,-0.473 -1.373,-0.473c-0.662,0 -1.325,0.284 -1.751,0.852c-1.704,2.129 -4.307,4.59 -9.56,4.59c-7.336,0 -13.299,-5.963 -13.299,-13.299c0,-7.336 5.963,-13.299 13.299,-13.299c5.301,0 7.904,2.461 9.56,4.591c0.757,0.946 2.13,1.136 3.124,0.378c0.946,-0.757 1.136,-2.129 0.378,-3.123c-1.23,-1.562 -4.969,-6.248 -13.062,-6.248c-9.75,0 -17.701,7.952 -17.701,17.701c0,9.75 7.951,17.654 17.701,17.654Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.546,19.498l-21.913,0c-1.231,0 -2.225,0.994 -2.225,2.224c0,1.231 0.994,2.225 2.225,2.225l21.865,0l-3.123,3.123c-0.426,0.426 -0.663,0.994 -0.663,1.562c0,0.568 0.237,1.136 0.663,1.562c0.852,0.852 2.272,0.852 3.123,0l6.863,-6.957c0.852,-0.852 0.852,-2.272 0,-3.124l-6.863,-6.957c-0.425,-0.426 -0.993,-0.663 -1.561,-0.663c-0.568,0 -1.136,0.237 -1.562,0.615c-0.426,0.426 -0.663,0.947 -0.663,1.562c0,0.568 0.237,1.136 0.615,1.562l3.219,3.266Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.2968b8e5c2e10d4b809cca67763bc51a.svg";
export { ForwardRef as ReactComponent };